import { useQuery } from '@tanstack/react-query';
import { getMyProfileV2, resolveAccessToken } from '@nomiss/services';

export const myProfileQueryKey = ['users', 'me', 'v2'] as const;

export function useMyProfile(accessToken?: string | null, enabled = true) {
  const token = accessToken ?? resolveAccessToken();

  return useQuery({
    queryKey: [...myProfileQueryKey, token ?? ''] as const,
    queryFn: () => getMyProfileV2(token),
    enabled: enabled && Boolean(token),
  });
}
